import React from 'react';

import BeardData from '../Data/BeardData';
import BeardPrice from './BeardPrice';


class BeardPrices extends React.Component {

    constructor() {
        super();
        this.state = {
            prices: BeardData
        }
    }


    render() {

        let allPrices = this.state.prices; // put the state into a var
        // then map over the var containing the state
        //using curly braces to return the BearPrice component with the props
        const allData = allPrices.map((item, index) => {
            return <BeardPrice text={item.text} price={item.price} key={item.index} />
        });


        return (
            // pass the allData loop inside the 
            <React.Fragment>
                {allData}
            </React.Fragment>
        )
    }

}

export default BeardPrices;